import React, { memo } from 'react';

import { ProductsIndexTableBodyProps } from './ProductsIndexTableBody.types';

import { ProductsIndexTableRow } from '../ProductsIndexTableRow';

function ProductsIndexTableBody({
  changeProductsFilters,
  companyNanoId,
  isMyLibrary,
  onLightboxOpen,
  onProductAiSearch,
  onProductEditButtonMouseEnter,
  onProductSimilarSearch,
  onProductSimilarSearchFilter,
  onProductsSelect,
  onSelectedProductsSidebarClose,
  onSelectedProductsSidebarOpen,
  products,
  productsCacheKeys,
  productsFilters,
  productsSet,
  productsSetCacheKeys,
  updateProductCache,
  updateProductsSetCache
}: ProductsIndexTableBodyProps) {
  return (
    <tbody>
      {products.map((product) => (
        <ProductsIndexTableRow
          changeProductsFilters={changeProductsFilters}
          companyNanoId={companyNanoId}
          isMyLibrary={isMyLibrary}
          key={product.uuid}
          onLightboxOpen={onLightboxOpen}
          onProductAiSearch={onProductAiSearch}
          onProductEditButtonMouseEnter={onProductEditButtonMouseEnter}
          onProductSimilarSearch={onProductSimilarSearch}
          onProductSimilarSearchFilter={onProductSimilarSearchFilter}
          onProductsSelect={onProductsSelect}
          onSelectedProductsSidebarClose={onSelectedProductsSidebarClose}
          onSelectedProductsSidebarOpen={onSelectedProductsSidebarOpen}
          product={product}
          productsCacheKeys={productsCacheKeys}
          productsFilters={productsFilters}
          productsSet={productsSet}
          productsSetCacheKeys={productsSetCacheKeys}
          updateProductCache={updateProductCache}
          updateProductsSetCache={updateProductsSetCache}
        />
      ))}
    </tbody>
  );
}

export default memo<ProductsIndexTableBodyProps>(ProductsIndexTableBody);
